export const generateState = (maxNum: number) => {
  const list: any = {}
  for (let step = 0; step < maxNum + 1; step++) {
    // 値が 0 から 4 まで計 5 回実行される
    const num = step + 1
    list[num] = false
  }
  return list
}
